import { render, staticRenderFns } from "./left_bar.vue?vue&type=template&id=47bbdbd6&scoped=true"
import script from "./left_bar.vue?vue&type=script&lang=ts"
export * from "./left_bar.vue?vue&type=script&lang=ts"
import style0 from "./left_bar.vue?vue&type=style&index=0&id=47bbdbd6&prod&lang=stylus"
import style1 from "./left_bar.vue?vue&type=style&index=1&id=47bbdbd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bbdbd6",
  null
  
)

export default component.exports